import $ from "jquery";
import {mapActions, mapMutations, mapState} from "vuex";

export const SendFormMixin = {
  data() {
    return {
      top: null,
      bottom: null,
      test: 0
    };
  },

  computed: {
    ...mapState({
      leadforced: (state) => state.forms.leadforced
    })
  },

  methods: {
    ...mapMutations({
      setFormsuccess: "forms/SET_FORMSUCCESS",
      setModalContentComputed: "forms/SET_MODAL_CONTENT_COMPUTED"
    }),
    ...mapActions({
      sendIframePost: "iframe/sendIframePost",
    }),

    async setFormDataField() {
      this.form.data.fields.map((item, index) => {
        if (Array.isArray(item)) {
          let data2 = item.filter(
            (y) =>
              y.group === "electricity" ||
              y.group === "gas" ||
              y.group === "electricityandgas"
          );
          if (data2.length > 0) {
            let sup = data2.filter((x) => x.type === "suppliers")[0];
            let rate_period = sup.suppliers.filter(
              (x) => x.id === sup.default
            )[0].rate_period;

            this.form.data.fields[index].filter(
              (x) => x.type === "duration"
            )[0].default = parseInt(rate_period);
          }
        }
      });
    },
    async sendForm() {

      $("#submit-alert").remove(); // TODO: is it necessary

      if (!this.isLead) {
        await this.setFormDataField();
      }

      this.setTopAndBottom();

      if (!this.isAlert()) {
        event.preventDefault();
        this.loading = true;
        var data = await this.prepareFormData(this.leadforced);

        this.sendIframePost(data)
          .then((response) => {

            if (this.isSuccess(response)) {
              this.loading = false;
              this.error = false; //  TODO: already false
              this.setFormsuccess(true)

              this.getSuccessPage();
            } else {

              this.setAsError(response.data.data);
            }
          });
      } else {
        this.alertMessage();
      }
    },

    getSuccessPage() {

      window.parentIFrame.autoResize(false)
      window.parentIFrame.size(500)
      window.parentIFrame.scrollTo(0,0)

    },
    setTopAndBottom() {
      if (this.isOverview && this.isMobile) {
        this.top = document.getElementById("mobile-overwiev").offsetTop;
        this.bottom = document.getElementById("mobile-overwiev").style.bottom;
      } else if (this.isOverview && !this.isMobile) {
        this.top = document.getElementById("sideBarRight").style.top;
      } else if (!this.isOverview) {
        this.top = document.getElementById("formessagetop").style.top;
      }
    },
    isAlert() {
      let alertCount = 0;
      let alerts = $("#formAction").find(".alert-danger");
      alerts.each((alert) => {
        if (alert.id !== "speed-alert" && alert.id !== "submit-alert") {
          alertCount++;
        }
      });

      return !(
        alertCount === 0 &&
        $("#date_of_birth").val() !== "" &&
        $("#issuedat").val() !== "" &&
        $("#expireat").val() !== "" &&
        $("#legitimation_type").val() !== null &&
        $("#nationality").val() !== null
      );
    },
    async prepareFormData(forceLead = false) {
      let form = document.getElementById("formAction");
      let formData = new FormData(form);

      formData = this.addMissedProductId(formData);
      formData = this.addLanguage(formData);
      formData = this.addMissedWidget(formData);
      let overview = await this.updateOverview(
        this.overview,
        formData,
        this.energieGroups
      );

      formData = this.appendData(formData, [
        { key: "id", value: this.$route.params.id },
        { key: "overview", value: JSON.stringify(overview) },
        { key: "clientID", value: this.clientID },
        { key: "isLead", value: this.isLead },
        { key: "redirect", value: this.$route.query.redirect ?? null},
        { key: "ga_client_id", value: this.$route.query.gaClientId ?? null},
        {
          key: "network_operator",
          value: this.handleChargeGridName("electricity"),
        },
        {
          key: "network_operator_costs_e",
          value: this.handleNetworkOperatorCosts("electricity"),
        },
        {
          key: "network_operator_costs_g",
          value: this.handleNetworkOperatorCosts("gas")||null,
        },
        {
          key: "network_operator_g_category",
          value: this.handleChargeGridName("gas")||null,
        },
      ]);

      // force lead?
      if(forceLead) {
        formData = this.appendData(formData, [
          { key: "forcelead", value: true }
        ]);
      }

      // direct of offer by email?
      // Temp hack for HelpenAansluiten
      if(this.$route.query.offerfirst == 1 || this.form.data.id == 739) {
        formData = this.appendData(formData, [
          { key: "direct", value: false }
        ]);
      }
      return { formData: formData, id: null };
    },
    handleNetworkOperatorCosts(name) {
      if (name == "electricity") {
        if (
          this.postcodeQuery &&
          this.postcodeQuery.network_operators["E"] &&
          !this.postcodeQuery.error
        ) {
          return this.postcodeQuery.network_operators["E"].filter(
            (x) => x.connection_value == "3x25"
          )[0].daily;
        }
      } else if (name == "gas") {
        let gasConsumption = parseInt(this.consumption.gas);
        if (this.postcodeQuery && !this.postcodeQuery.error) {
          let postCodeGasOperators = this.postcodeQuery.network_operators["G"];
          if (postCodeGasOperators) {
            if (500 > gasConsumption) {
              return postCodeGasOperators.filter(
                (x) => x.connection_value == "G6 < 500 m3"
              )[0].daily;
            } else if (500 <= gasConsumption && gasConsumption < 4000) {
              return postCodeGasOperators.filter(
                (x) => x.connection_value == "G6 < 4000 m3"
              )[0].daily;
            } else if (gasConsumption >= 4000) {
              return postCodeGasOperators.filter(
                (x) => x.connection_value == "G6 >= 4000 m3"
              )[0].daily;
            }
          }
        }
      }
    },
    handleChargeGridName(name) {
      if (name == "electricity") {
        if (
          this.postcodeQuery &&
          this.postcodeQuery.network_operators["E"] &&
          !this.postcodeQuery.error
        ) {
          return this.postcodeQuery.network_operators["E"].filter(
            (x) => x.connection_value == "3x25"
          )[0].name;
        }
      } else if (name == "gas") {
        let gasConsumption = parseInt(this.consumption.gas);
        if (this.postcodeQuery && !this.postcodeQuery.error) {
          let postCodeGasOperators = this.postcodeQuery.network_operators["G"];
          if (postCodeGasOperators) {
            if (500 > gasConsumption) {
              return postCodeGasOperators.filter(
                (x) => x.connection_value == "G6 < 500 m3"
              )[0].name;
            } else if (500 <= gasConsumption && gasConsumption < 4000) {
              return postCodeGasOperators.filter(
                (x) => x.connection_value == "G6 < 4000 m3"
              )[0].name;
            } else if (gasConsumption >= 4000) {
              return postCodeGasOperators.filter(
                (x) => x.connection_value == "G6 >= 4000 m3"
              )[0].name;
            }
          }
        }
      }
    },
    addMissedProductId(formData) {
      if (
        formData.has("products[electricityandgas][duration]") &&
        !formData.has("products[electricityandgas][id]")
      ) {
        formData.append("products[electricityandgas][id]", 6);
      }

      return formData;
    },
    addMissedWidget(formData) {
      formData.append(
        "widgets[mobile][number_retention][status]",
        $("#number_retention").prop("checked")
      );
      formData.append(
        "widgets[mobile][number_retention][phone]",
        $("#phone3").val()
      );
      return formData;
    },
    addLanguage(formData) {
      formData.append("language", this.lang);
      if (!formData.has("widgets[personaldata][language_id]")) {
        formData.append(
          "widgets[personaldata][language_id]",
          this.languageEnum[this.lang]
        );
      }

      return formData;
    },
    updateOverview(overview, formData, energieGroups) {
      for (let i = 0; i < overview.length; i++) {
        let monthly = 0;
        let discount = 0;
        let discountPeriod = 0;
        let monthlyWithDiscount = 0;
        let yearly = 0;
        let yearlyWithDiscount = 0;

        let elem = overview[i];

        //update duration
        if (elem.duration === "") {
          elem.duration = formData.get(
            `products[${energieGroups[elem.id]}][duration]`
          );
        }
        //create receipt
        monthly =
          elem.total +
          (elem.packagestotal ? parseFloat(elem.packagestotal) : 0);
        discount = elem.discount ? elem.discount.rate : 0;
        discountPeriod = elem.discount ? elem.discount.period : 0;
        monthlyWithDiscount = monthly > 0 ? monthly + discount : 0;

        yearly = monthly * 12;
        yearlyWithDiscount = yearly + discount * discountPeriod;

        elem.receipt = {
          monthly,
          monthlyWithDiscount,
          yearly,
          yearlyWithDiscount,
        };
      }

      return overview;
    },
    appendData(form, data) {
      data.forEach((item) => {
        form.append(item.key, item.value);
      });

      return form;
    },
    isSuccess(response) {
      return response && JSON.parse(response.data.data).id;
    },
    setAsSuccess() {
      this.loading = false;
      this.error = false; //  TODO: already false
      this.setFormsuccess(true)
    },
    setAsError(data) {
      let tempError = "";
      if (JSON.parse(data).status_code >= 500) {
        tempError +=
          "<a name='swal-error'><p class='mb-0'>- " +
          JSON.parse(data).message +
          "</p></a>";
      } else {
        Object.values(JSON.parse(data).errors).forEach((x) => {
          tempError +=
            "<a name='swal-error'><p class='mb-0'>- " + x + "</p></a>";
        });
      }

      this.loading = false;
      this.success = false;

      this.$swal({
        icon: "error",
        title: this.translate[this.lang]["look-up"],
        html: tempError,
      });
    },
    alertMessage() {
      let vueThis = this;
      $("#date-of-birth-alert").remove();
      $("#issued-alert").remove();
      $("#expire1-alert").remove();
      $("#submit1-alert").remove();
      $("#legitimation_type-alert").remove();
      if ($("#legitimation_type").val() === null) {
        $("#legitimation_type")
          .parent()
          .parent()
          .append(
            '<div class="col-md-12 " id="legitimation_type-alert"><div class="alert alert-danger" role="alert" id="submit-alert"><p class="mb-0">' +
              vueThis.translate[vueThis.lang]["legitimation_type-1"] +
              "" +
              "</p></div></div>"
          );
      }
      if ($("#date_of_birth").val() === "") {
        $("#date_of_birth")
          .parent()
          .parent()
          .append(
            '<div class="col-md-12 " id="date-of-birth-alert"><div class="alert alert-danger" role="alert" id="submit-alert"><p class="mb-0">' +
              vueThis.translate[vueThis.lang]["date_of_birth-1"] +
              "</p></div></div>"
          );
      }
      if ($("#issuedat").val() === "") {
        $("#issuedat")
          .parent()
          .parent()
          .append(
            '<div class="col-md-12 " id="issued-alert"><div class="alert alert-danger" role="alert" id="submit-alert"><p class="mb-0">' +
              vueThis.translate[vueThis.lang]["issuedat-1"] +
              "</p></div></div>"
          );
      }
      if ($("#expireat").val() === "") {
        $("#expireat")
          .parent()
          .parent()
          .append(
            '<div class="col-md-12 " id="expire1-alert"><div class="alert alert-danger" role="alert" id="submit-alert"><p class="mb-0">' +
              vueThis.translate[vueThis.lang]["expireat-2"] +
              "</p></div></div>"
          );
      }
      if ($("#nationality").val() == null) {
        $("#nationality")
          .parent()
          .append(
            '<div class="col-md-12 " id="nationality-alert"><div class="alert alert-danger" role="alert" id="submit-alert"><p class="mb-0">' +
              "Please select one" +
              "</p></div></div>"
          );
      }
      $("#submit-button")
        .parent()
        .append(
          '<div class="col-md-12" id="submit1-alert"><div class="alert alert-danger" role="alert" id="submit-alert" ><p class="mb-0">' +
            vueThis.translate[vueThis.lang]["submit-button-1"] +
            "</p></div></div>"
        );
    },
  },
};
